<template>
  <div class="plv-iar-input pws-iar-input">
    <slot name="prefix"></slot>
    <div class="plv-iar-input__body">
      <input
        class="plv-iar-input__native pws-iar-input-native"
        :placeholder="placeholder"
        :value="value"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
      />
    </div>
    <slot name="suffix">
      <div v-if="value" class="plv-iar-input__clear" @click="clear">
        <icon-close class="plv-iar-input__clear__icon" />
      </div>
    </slot>
  </div>
</template>

<script>
import { IconClose } from '@/icon-components/map';

export default {
  props: {
    value: String,
    placeholder: {
      type: String,
      default: '',
    },
  },

  components: {
    IconClose,
  },

  methods: {
    onInput(e) {
      const val = e.target.value;
      this.$emit('input', val);
    },

    clear() {
      this.$emit('input', '');
    },

    onFocus() {
      this.$emit('input-focus');
    },

    onBlur() {
      this.$emit('input-blur');
    }
  },
};
</script>

<style lang="scss">
.plv-iar-input {
  display: flex;
  align-items: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;
  height: 32px;
  padding: 0 12px;
}
.plv-iar-input__body {
  flex: 1;
  height: 100%;
}
.plv-iar-input__native {
  display: block;
  width: 100%;
  background: none;
  border: none;
  outline: none;
  height: 100%;
  box-sizing: border-box;
  font-size: 14px;
  color: #fff;
}
.plv-iar-input__clear {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-left: 6px;
  background: rgba(#fff, 0.1);
  flex-shrink: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.plv-iar-input__clear__icon {
  font-size: 12px;
  color: rgba(#fff, 0.3);
  display: flex;
  transform: scale(0.8);
}
</style>
